const privacyPolicy = document.querySelector('.privacy-policy__popup');

if (null !== privacyPolicy) {
	const btnAgree = document.querySelector('.privacy-policy__agree');
	const cookiePath = '/';
	const cookieExpiry = '365';

	const agree = () => {
		privacyPolicy.classList.remove('privacy-policy__popup--open');
		createCookie('privacyPolicyAgree', 'yes', cookieExpiry, cookiePath);
	};

	const readCookie = (name) => {
		const nameEQ = name + '=';
		const ca = document.cookie.split(';');

		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];

			while (' ' === c.charAt(0)) {
				c = c.substring(1, c.length);
			}

			if (0 === c.indexOf(nameEQ)) {
				return c.substring(nameEQ.length, c.length);
			}
		}
		return null;
	};

	const createCookie = (name, value, days, path) => {
		let expires = '';
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toGMTString();

		document.cookie = name + '=' + value + expires + '; path=' + path;
	};

	if ('yes' === readCookie('privacyPolicyAgree')) {
		privacyPolicy.remove();
	} else {
		privacyPolicy.classList.add('privacy-policy__popup--open');
	}

	btnAgree.onclick = () => {
		agree();
	};
}
